<template>
  <section id="RegisterForm">
    <div class="text-center mb-3">
      <img
        alt
        :src="$storeIndex.getImageGobalAssets('authorization/logo-goship-gosell')"
        class="logo-goship-gosell"
      >
    </div>
    <div
      class="text-center mb-3 h3 pt-2"
      v-if="this.registerType == 'socialRegister'"
    >
      {{ $t('Register') }}
    </div>
    <div v-if="!alreadySend">
      <div
        class="form-group form-group-feedback form-group-feedback-left"
        :class="{ 'form-group-error': $v.form.fullname.$error }"
      >
        <input
          type="text"
          class="form-control"
          :placeholder="$t('Full Name')"
          v-model.trim.lazy="$v.form.fullname.$model"
          @keyup="realtime($event,'fullname')"
          @paste="realtime($event,'fullname')"
        >
        <div class="form-control-feedback">
          <i class="fa-user-check far text-muted" />
        </div>
        <div
          v-if="!$v.form.fullname.required"
          class="validation-invalid-label"
        >
          {{ $t("Please enter fullname") }}.
        </div>
        <div
          v-else-if="!$v.form.fullname.minLength"
          class="validation-invalid-label"
        >
          {{
            $t("Name must have at least") +
              " " +
              $v.form.fullname.$params.minLength.min +
              " " +
              $t("letters.")
          }}
        </div>
      </div>
      <div
        class="form-group form-group-feedback form-group-feedback-left"
        :class="{ 'form-group-error': $v.form.telephone.$error }"
      >
        <input
          type="text"
          class="form-control"
          :placeholder="$t('Phone')"
          v-model.trim.lazy="$v.form.telephone.$model"
        >
        <div class="form-control-feedback">
          <i class="fa-mobile-alt fas text-muted" />
        </div>
        <div
          v-if="!$v.form.telephone.required"
          class="validation-invalid-label"
        >
          {{ $t("Please enter telephone.") }}
        </div>
        <div
          v-else-if="!$v.form.telephone.numeric"
          class="validation-invalid-label"
        >
          {{ $t("Telephone must be only numeric.") }}
        </div>
        <div
          v-else-if="!$v.form.telephone.checkIsValidPhoneNumber"
          class="validation-invalid-label"
        >
          {{ $t("Invalid telephone format") }}
        </div>
        <div
          v-else-if="!$v.form.telephone.isUniquePhoneNumber"
          class="validation-invalid-label"
        >
          {{ $t("This telephone already registered.") }}
        </div>
      </div>
      <div :class="['form-group','form-group-feedback','form-group-feedback-left',mailValidGroupClass ]">
        <input
          type="email"
          class="form-control"
          :placeholder="$t('Email')"
          v-model.trim.lazy="$v.form.email.$model"
        >
        <div class="form-control-feedback">
          <i class="fa-at far text-muted" />
        </div>
        <div
          v-if="!$v.form.email.required"
          class="validation-invalid-label"
        >
          {{ $t("Please enter email.") }}
        </div>
        <div
          v-else-if="!$v.form.email.email"
          class="validation-invalid-label"
        >
          {{ $t("Email invalid") }}
        </div>
        <!-- <div v-else-if="!$v.form.email.isblacklistEmail" class="validation-invalid-label">This email is blacklisted.</div> -->
        <div
          v-else-if="!$v.form.email.isRegisteredEmail"
          class="validation-invalid-label"
        >
          {{ $t(messageEmail) }}
        </div>
        <div
          v-if="!$v.form.email.isRegisteredEmail && subStatus && subStatusMessage"
          style="color: #999999;font-size: 12px"
        >
          {{ $t('_Email.Response Message') + ': ' + $t(subStatusMessage) }}
        </div>
        <!-- <div v-else-if="!$v.form.email.isExistEmail" class="validation-invalid-label">This email doesn't exist.</div> -->
      </div>
      <div
        class="form-group form-group-feedback form-group-feedback-left"
        :class="{ 'form-group-error': $v.form.password.$error }"
      >
        <div
          class="popover bs-popover-right valid-password"
          v-if="
            $v.form.password.required && !$v.form.password.minLength && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.maxLength && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.continuously && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.relatedToUser && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.uppercase && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.lowercase && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.number && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.special && $v.form.couponReferCode.$model.length == 0
          "
        >
          <div class="arrow valid-arrow" />
          <div class="popover-body text-size-13">
            <div class="d-flex">
              <i
                class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                v-if="!$v.form.password.minLength"
              />
              <i
                class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                v-else
              />
              {{ $t('Password must have at least') + ' ' + $v.form.password.$params.minLength.min + ' ' + $t('digits.') }}
            </div>
            <div class="d-flex">
              <i
                class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                v-if="!$v.form.password.maxLength"
              />
              <i
                class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                v-else
              />
              {{ $t('Password must have at most') + ' ' + $v.form.password.$params.maxLength.max + ' ' + $t('digits.') }}
            </div>
            <div class="d-flex">
              <i
                class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                v-if="!$v.form.password.continuously"
              />
              <i
                class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                v-else
              />
              {{ $t('Consecutive letters or numbers cannot be used') }}
            </div>
            <div class="d-flex">
              <i
                class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                v-if="!$v.form.password.relatedToUser"
              />
              <i
                class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                v-else
              />
              {{ $t("Can't use words related to user") }}
            </div>
            <div class="d-flex">
              <i
                class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                v-if="!$v.form.password.uppercase"
              />
              <i
                class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                v-else
              />
              {{ $t('At least 1 uppercase letter') }}
            </div>
            <div class="d-flex">
              <i
                class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                v-if="!$v.form.password.lowercase"
              />
              <i
                class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                v-else
              />
              {{ $t('At least 1 lowercase letter') }}
            </div>
            <div class="d-flex">
              <i
                class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                v-if="!$v.form.password.number"
              />
              <i
                class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                v-else
              />
              {{ $t('At least 1 number') }}
            </div>
            <div class="d-flex">
              <i
                class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                v-if="!$v.form.password.special"
              />
              <i
                class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                v-else
              />
              {{ $t('At least 3 special characters') }}
            </div>
          </div>
        </div>
        <input
          :type="showPasswordType"
          :class="['form-control' ,
                   $v.form.password.required && $v.form.couponReferCode.$model.length == 0 ?
                     !$v.form.password.minLength ||
                     !$v.form.password.maxLength ||
                     !$v.form.password.continuously ||
                     !$v.form.password.relatedToUser ||
                     !$v.form.password.uppercase ||
                     !$v.form.password.lowercase ||
                     !$v.form.password.number ||
                     !$v.form.password.special ?
                       'border-danger' : 'border-success'
                     : ''
          ]"
          :placeholder="$t('Password')"
          v-model.trim.lazy="$v.form.password.$model"
          @keyup="realtime($event,'password')"
        >
        <div class="form-control-feedback">
          <i class="far fa-user-lock text-muted" />
        </div>
        <div
          v-if="
            $v.form.password.required && !$v.form.password.minLength && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.maxLength && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.continuously && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.relatedToUser && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.uppercase && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.lowercase && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.number && $v.form.couponReferCode.$model.length == 0 ||
              $v.form.password.required && !$v.form.password.special && $v.form.couponReferCode.$model.length == 0
          "
          class="form-control-feedback text-danger icon-mark-2"
        >
          <i class="icon-cancel-circle2" />
        </div>
        <div
          v-else-if="$v.form.password.required && $v.form.couponReferCode.$model.length == 0"
          class="form-control-feedback text-success icon-mark-2"
        >
          <i class="icon-checkmark-circle" />
        </div>
        <span class="form-control-feedback icon-mark-1">
          <a
            class="cursor-pointer"
            @click="showPassword"
          ><i :class="iconShowPassword" /></a>
        </span>
        <div
          v-if="!$v.form.password.required"
          class="validation-invalid-label"
        >
          {{ $t("Please enter password.") }}
        </div>
        <div
          v-else-if="!$v.form.password.minLength && $v.form.couponReferCode.$model.length != 0"
          class="validation-invalid-label"
        >
          {{ $t("Password must have at least") + " " + $v.form.password.$params.minLength.min + " " + $t("digits.") }}
        </div>
        <div
          v-else-if="!$v.form.password.maxLength && $v.form.couponReferCode.$model.length != 0"
          class="validation-invalid-label"
        >
          {{ $t("Password must have at most") + " " + $v.form.password.$params.maxLength.max + " " + $t("digits.") }}
        </div>
      </div>
      <div
        class="form-group form-group-feedback form-group-feedback-left"
        :class="{
          'form-group-error': $v.form.repeatPassword.$error,
        }"
      >
        <input
          :type="showConfirmPasswordType"
          :class="['form-control' ,
                   $v.form.repeatPassword.required && $v.form.couponReferCode.$model.length == 0 ?
                     !$v.form.repeatPassword.sameAsPassword ?
                       'border-danger' : 'border-success'
                     : ''
          ]"
          :placeholder="$t('Confirm Password')"
          v-model.trim="$v.form.repeatPassword.$model"
          @keyup="realtime($event,'repeatPassword')"
        >
        <div class="form-control-feedback">
          <i class="far fa-user-lock text-muted" />
        </div>
        <div
          v-if="$v.form.repeatPassword.required && !$v.form.repeatPassword.sameAsPassword && $v.form.couponReferCode.$model.length == 0"
          class="form-control-feedback text-danger icon-mark-2"
        >
          <i class="icon-cancel-circle2" />
        </div>
        <div
          v-else-if="$v.form.repeatPassword.required && $v.form.couponReferCode.$model.length == 0"
          class="form-control-feedback text-success icon-mark-2"
        >
          <i class="icon-checkmark-circle" />
        </div>
        <span class="form-control-feedback icon-mark-1">
          <a
            class="cursor-pointer"
            @click="showConfirmPassword"
          ><i :class="iconConfirmShowPassword" /></a>
        </span>
        <div
          v-if="!$v.form.repeatPassword.required"
          class="validation-invalid-label"
        >
          {{ $t("Please enter confirm password.") }}
        </div>
        <div
          v-else-if="!$v.form.repeatPassword.sameAsPassword && $v.form.couponReferCode.$model.length != 0"
          class="validation-invalid-label"
        >
          {{ $t('Confirm Passwords must be the same as "Password".') }}
        </div>
      </div>
      <div
        class="form-group"
        id="generate"
      >
        <div class="row">
          <div class="col-12 col-sm-6">
            <button
              type="button"
              class="col-12 btn btn-outline bg-slate-600 text-slate-600 border-slate-600"
              @click="generatePassword(8)"
            >
              <i class="fa-solid fa-arrows-rotate mr-1" />{{ $t("_Password.Generate Password") }}
            </button>
          </div>
          <div class="col-12 col-sm-6">
            <button
              type="button"
              class="col-12 btn btn-outline bg-slate-600 text-slate-600 border-slate-600"
              v-clipboard:copy="genPasswordCopy"
              v-clipboard:success="copySuccess"
            >
              <i class="fa-regular fa-copy mr-1" />{{ $t('Copy') }}
            </button>
          </div>
        </div>
      </div>
      <div
        class="form-group form-group-feedback form-group-feedback-left"
        :class="{
          'form-group-error': $v.form.couponReferCode.$invalid,
        }"
      >
        <input
          type="text"
          class="form-control"
          :placeholder="$t('Refer Code/Coupon Code')+' ('+$t('Not Required')+')'"
          @input="$v.form.couponReferCode.$touch"
          v-model.trim="$v.form.couponReferCode.$model"
          @keyup="realtime($event,'couponReferCode')"
        >
        <div class="form-control-feedback">
          <i class="fa-solid fa-ticket text-muted" />
        </div>
        <div
          v-if="!$v.form.couponReferCode.isReferCode && errorMessageReferCode != ''"
          class="validation-invalid-label"
        >
          {{ $t(errorMessageReferCode) }}
        </div>
      </div>

      <div class="form-group f-14">
        <p class="text-muted">
          {{ $t("By signing up a new account,") }}
        </p>
        <div class="d-flex">
          <div class="pl-4 custom-checkbox custom-control-inline mr-0">
            <input
              type="checkbox"
              class="custom-control-input"
              id="agree-term-policy"
              :checked="agreeTermPolicy"
              @change="() => agreeTermPolicy = !agreeTermPolicy"
            >
            <label
              class="custom-control-label"
              for="agree-term-policy"
            />
          </div>
          <p class="text-muted">
            <span class="text-muted">{{ $t("I have agree to") }}
              <a
                :href="urlTermsConditions"
                target="_blank"
              >
                {{ $t("Terms of Services") }}
              </a>
              {{ $t("and") }}
              <a
                :href="urlPrivacyPolicy"
                target="_blank"
              >
                {{ $t("Privacy Policy.") }}
              </a>
            </span>
          </p>
        </div>
      </div>

      <div class="form-group text-center text-muted content-divider">
        <span class="px-2">{{ $t("or sign up with") }}</span>
      </div>

      <div class="form-group">
        <div class="d-flex justify-content-around">
          <button
            type="button"
            @click="handleSocialLogin('google')"
            class="btn bg-google btn-block my-0 text-indigo-400 d-flex justify-content-center align-items-center"
          >
            <i class="fa-brands fa-google f-18" />
          </button>
          <button
            type="button"
            @click="handleSocialLogin('facebook')"
            class="btn bg-facebook btn-block my-0 mx-2 text-indigo-400 d-flex justify-content-center align-items-center"
          >
            <i class="fa-brands fa-facebook-f f-18" />
          </button>
          <button
            type="button"
            @click="handleSocialLogin('line')"
            class="btn bg-line btn-block my-0 text-indigo-400 d-flex justify-content-center align-items-center"
          >
            <i class="fa-brands fa-line f-18" />
          </button>
          <button
            type="button"
            @click="handleSocialLogin('apple')"
            class="btn bg-apple btn-block my-0 ml-2 text-indigo-400 d-flex justify-content-center align-items-center"
          >
            <i class="fa-brands fa-apple f-18" />
          </button>
        </div>
      </div>

      <div class="justify-content-center mt-0 mx-4 mb-3">
        <vue-recaptcha
          ref="recaptcha"
          @verify="onRecaptchaVerify"
          :load-recaptcha-script="true"
          :sitekey="siteKey"
          :model-value="responseVerify"
          @expired="onRecaptchaExpired"
          @error="onRecaptchaError"
        />
        <span
          v-show="responseVerify == '' && alertVerifyCaptcha"
          class="text-danger"
        >
          *{{ $t("Verify that you are not robot.") }}
        </span>
      </div>

      <div
        class="form-group"
        id="btnRegister"
      >
        <ladda
          text="Register"
          :btn-class="'btn btn-primary btn-block'"
          :loading="loading"
          icon="<i class='fa fa-sign-in-alt'></i>"
          :disabled="$v.validationGroup.$invalid"
          @click="sendSelectVerify()"
        />
      </div>
    </div>

    <div v-if="alreadySend">
      <section v-if="!alreadyCode">
        <div class="form-group">
          <div class="text-center mb-3">
            <h3>{{ $t("Verification") }}</h3>
            <p class="text-muted">
              {{ $t("Please select verification method.") }}
            </p>
          </div>
        </div>

        <!-- Verification Code Email And SMS -->
        <div
          v-for="(menu, index) of menuVerificationCode"
          :key="index"
          class="form-group"
        >
          <ul
            class="list-group list-group-flush py-0 border rounded"
            style="cursor: pointer"
            @click="!selectloading ? selectVerifyOption(menu.type) : ''"
          >
            <li
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-2 px-3"
            >
              <div class="pl-1">
                <div class="d-flex flex-row">
                  <h3
                    class="m-0 mr-3 text-primary"
                    :class="[...menu.icon]"
                    style="padding-top: 2px"
                  />
                  <div>
                    <div class="h6 font-weight-semibold">
                      {{ menu.title }}
                    </div>
                    <div class="text-secondary mt-n1">
                      <span
                        v-if="menu.type === 'verify_sms'"
                        style="font-weight: 500;font-size: 18px; margin-right:1px; letter-spacing: 0.10em;"
                      >
                        ··· ···
                      </span>
                      {{ menu.description }}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <i
                  class="far text-muted"
                  :class="!menu.menuloading ? 'fa-chevron-right' : 'loading-sm'"
                />
              </div>
            </li>
          </ul>
        </div>
        <!-- Verification Code Email And SMS End -->

        <div class="form-group">
          <button
            type="button"
            @click="!selectloading ? backRegister() : ''"
            class="btn btn-light btn-block"
          >
            {{ $t("Back") }}
          </button>
        </div>
      </section>
      <section v-if="alreadyCode">
        <verification-code />
      </section>
    </div>

    <div>
      <div class="form-group mb-0">
        <div class="btn-group-justified">
          <ul
            class="m-auto navbar-nav"
            style="width: 125px"
          >
            <li class="nav-item dropdown language-switch">
              <a
                class="navbar-nav-link dropdown-toggle"
                data-toggle="dropdown"
              >
                <img
                  :src="
                    $storeIndex.getImageSrc('lang/' + lang)
                  "
                  class="img-flag mr-2"
                  alt=""
                >
                {{ $t(title) }}
              </a>
              <div class="dropdown-menu">
                <a
                  v-for="(value, key) in localList"
                  :name="key"
                  :key="`lang-${key}`"
                  @click="selectLang(key)"
                  href="javascript:void(0);"
                  class="dropdown-item english"
                >
                  <img
                    :src="
                      $storeIndex.getImageSrc(
                        'lang/' + key
                      )
                    "
                    class="img-flag"
                    alt=""
                  >
                  {{ $t(value) }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CentralApi from "@/services/endpoint/central.service";
import AuthService from "@/services/auth.service";
import { isValidPhoneNumber } from "libphonenumber-js";
import {
    required,
    minLength,
    maxLength,
    sameAs,
    email,
    numeric,
} from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";
import Ladda from "@/plugins/Ladda.vue";
import { localSave, localRead } from "@/store/lang";
import bcrypt from "bcryptjs";
import VerificationCode from './VerificationCode';
import Cookies from 'js-cookie';
import { v4 as uuid } from 'uuid';
import VueRecaptcha from 'vue-recaptcha';

const checkIsValidPhoneNumber = (phoneNumber) =>
    isValidPhoneNumber(phoneNumber, "TH");

export default {
    name: "RegisterForm",
    components: {
        Ladda,
        VerificationCode,
        'vue-recaptcha': VueRecaptcha
    },
    props: {
        registerType: {
            default: null,
            type: String
        },
        socialUser:{
            default:null,
            type:Object
        }
    },
    data() {
        return {
            inputVerficationCode: "",
            alreadySend: false,
            alreadyCode: false,
            verifyOption: "",
            verificationCode: "",
            refCodeId:"",
            loading: false,
            selectloading: false,
            menuVerificationCode: [],
            urlPrivacyPolicy: process.env.GOSHIP_URL + "/privacy-policy",
            urlTermsConditions: process.env.GOSHIP_URL + "/terms-conditions",
            countDown: 0,
            message: "",
            messageEmail: "",
            subStatus: false,
            subStatusMessage: '',
            lang: localRead("local"),
            localList: {
                th: "Thai",
                en: "English",
            },
            form: {
                fullname: "",
                telephone: "",
                email:"",
                password: "",
                repeatPassword: "",
                couponReferCode: "",
            },
            errorMessageReferCode: "",
            showPasswordType: "password",
            iconShowPassword: "far fa-eye-slash",
            showConfirmPasswordType: "password",
            iconConfirmShowPassword: "far fa-eye-slash",
            mailValidGroupClass:"form-group-success",
            agreeTermPolicy: false,
            siteKey: '6Ldz_rcqAAAAANC72R7LwjMbU014QigbrVURnI_0',
            responseVerify: '',
            alertVerifyCaptcha: false,
        };
    },
    computed: {
        title() {
            return this.localList[this.lang];
        },
    },
    created() {

    },
    validationConfig: {
        $lazy: true,
    },
    validations: {
        form: {
            fullname: {
                required,
                minLength: minLength(4),
            },
            telephone: {
                required,
                numeric,
                checkIsValidPhoneNumber,
                async isUniquePhoneNumber(phoneNumber) {
                    if (
                        phoneNumber === "" ||
                        this.$v.form.telephone.checkIsValidPhoneNumber === false
                    )
                        return true;
                    const res = await CentralApi.Auth.isUniquePhoneNumber(
                        phoneNumber
                    );
                    let data = res.data.registered;
                    return data;
                },
            },
            email: {
                required,
                email,
                async isRegisteredEmail(emailAddress) {
                    if (
                        emailAddress === "" ||
                        this.$v.form.email.email === false
                    )
                        return true;
                    const res = await CentralApi.Auth.isEmailValidV2(
                        emailAddress
                    );
                    let data = res.data;

                    if (data.valid !== true) {
                        this.messageEmail = data.message;
                        this.mailValidGroupClass = "form-group-error"
                    }

                    if (data.valid !== true && (data.sub_status != undefined && data.sub_status != '')) {
                        let errorMessage = this.emailInvalidMessage(data.sub_status);
                        if (errorMessage != '') {
                          this.subStatus = true;
                          this.subStatusMessage = errorMessage;
                        }
                    } else {
                        this.subStatus = false;
                        this.subStatusMessage = '';
                    }
                    return data.valid;
                },
            },
            password: {
                required,
                relatedToUser: function(value) {
                    if(this.$v.form.couponReferCode.$model.length != 0) return true;
                    if(this.form.fullname.length != 0) {
                        var fullname = this.form.fullname.split(" ");
                        for(let i=0;i<fullname.length;i++) {
                            if(value.indexOf(fullname[i]) != -1) {
                                return false;
                            }else if(fullname.length == (i+1)) {
                                return true;
                            }
                        }
                    }else{
                        return true;
                    }
                },
                uppercase: function(value) {
                    if(this.$v.form.couponReferCode.$model.length != 0) return true;
                    return /[A-Z]{1}/.test(value);
                },
                lowercase: function(value) {
                    if(this.$v.form.couponReferCode.$model.length != 0) return true;
                    return /[a-z]{1}/.test(value);
                },
                number: function(value) {
                    if(this.$v.form.couponReferCode.$model.length != 0) return true;
                    return /[0-9]{1}/.test(value);
                },
                special: function(value) {
                    if(this.$v.form.couponReferCode.$model.length != 0) return true;
                    if(value.length > 0) {
                        var regex = /^[A-Za-z0-9 ]+$/;
                        for(let special=0,i=0;i<value.length;i++) {
                            if(!regex.test(value[i])) {
                                special++;
                            }
                            if(value.length == (i+1)) {
                                if(special >= 3) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        }
                    } else {
                        return false;
                    }
                },
                continuously: function(value) {
                    if(this.$v.form.couponReferCode.$model.length != 0) return true;
                    if(value.length > 0) {
                        for(let i=0;i<value.length;i++) {
                            if(i>0 && value[i-1] == value[i]) {
                                return false;
                            } else if(value.length == (i+1)) {
                                return true;
                            }
                        }
                    } else {
                        return true;
                    }
                },
                minLength: minLength(8),
                maxLength: maxLength(16),
            },
            repeatPassword: {
                required,
                sameAsPassword: sameAs("password"),
            },
            couponReferCode: {
                async isReferCode(referCode) {
                    this.errorMessageReferCode = "";
                    // if ( /\s/g.test(referCode) ) {
                    //     this.errorMessageReferCode = "Coupon not found, please re-type again.";
                    //     return false;
                    // }
                    if (referCode !== "" ){
                        const res = await CentralApi.Auth.getCheckCoupon('?coupon='+referCode);
                        if (!res.data.status) {
                            this.errorMessageReferCode = res.data.message
                        }
                        return res.data.status
                    }
                    return true;
                },
            },
            policy : {
              agreeTermPolicy() {
                return this.agreeTermPolicy
              }
            },
            recaptcha: {
              responseVerify() {
                return this.responseVerify ? true : false;
              }
            }
        },
        validationGroup: [
            "form.fullname",
            "form.telephone",
            "form.email",
            "form.password",
            "form.repeatPassword",
            "form.couponReferCode",
            "form.policy",
            "form.recaptcha",
        ],
    },
    methods: {
        genPasswordCopy() {
            return this.$v.form.repeatPassword.$model;
        },
        copySuccess(e) {
            this.$toastr.Add({
                type: "success",
                title: "<span class='t-icon icon-checkmark3'></span>"+this.$t('Success'),
                msg: this.$t('Copy password success.'),
                clickClose: true,
                timeout: 2000,
                position: "toast-top-right"
            });
            this.showPasswordType = "password";
            this.iconShowPassword = "far fa-eye-slash";
            this.showConfirmPasswordType = "password";
            this.iconConfirmShowPassword = "far fa-eye-slash";
        },
        emailInvalidMessage(status) {
          let message = '';
            switch (status) {
              case 'antispam_system':
                message = 'The email is protected by an anti-spam system. This prevents us from verifying its authenticity. Please contact the admin.';
                break;
              case 'does_not_accept_mail':
                message = 'This domain allows sending email only. Unable to receive email. Please use another email.';
                break;
              case 'exception_occurred':
                message = 'We encountered an exception while validating this email. Please ensure the email is correct and try again.';
                break;
              case 'failed_smtp_connection':
                message = "This email belongs to a mail server that won't allow an SMTP connection. Please use another email.";
                break;
              case 'failed_syntax_check':
                message = 'This email failed to use the RFC syntax protocol. Please use another email.';
                break;
              case 'forcible_disconnect':
                message = 'This email belongs to a mail server that disconnects immediately when a connection is established. Please use another email.';
                break;
              case 'global_suppression':
                message = 'This email was found on many popular global suppression lists (GSLs). Please use another email.';
                break;
              case 'greylisted':
                message = 'This email is temporarily unable to be validated. Please try again.';
                break;
              case 'mail_server_did_not_respond':
                message = 'This mail server is not responding to mail commands. Please use another email.';
                break;
              case 'mail_server_temporary_error':
                message = 'This mail server returned a temporary error. Please try again.';
                break;
              case 'mailbox_quota_exceeded':
                message = 'This email exceeds the mailbox quota and unable to receiv email. Please clear your mailbox space.';
                break;
              case 'mailbox_not_found':
                message = 'This email does not exist. Please use another email.';
                break;
              case 'no_dns_entries':
                message = 'The domain is not recorded in DNS or is recorded but incomplete. Makes it impossible to send email. Please use another email.';
                break;
              case 'possible_trap':
                message = 'This email contains keywords that could be related to possible spam traps, such as spam@ or @spam.com. Please use another email.';
                break;
              case 'possible_typo':
                message = 'Misspelled domains. Please ensure the email is correct and try again.';
                break;
              case 'role_based':
                message = 'This email belongs to role-based emails that are often reported as spam and abuse. Please use another email.';
                break;
              case 'role_based_catch_all':
                message = 'This email is role-based and also belongs to the catch_all domain. Please use another email.';
                break;
              case 'timeout_exceeded':
                message = 'This email belongs to a mail server that is responding extremely slowly. Please use another email.';
                break;
              case 'unroutable_ip_address':
                message = 'This email domain points to an un-routable IP address. Please use another email.';
                break;
              case 'disposable':
                message = 'This email is temporary and has a short lifespan ranging from 15 minutes to approximately 6 months. Please use another email.';
                break;
              case 'toxic':
                message = 'This email is abused, spam, or bot-created emails. Please use another email.';
                break;
              default:
                break;
            }
            return message;
        },
        generatePassword(quantity) {
            let strText = [
                "!@#$%^&*",                     // special
                "ABCDEFGHIJKLMNOPQRSTUVWXYZ",   // uppercase
                "abcdefghijklmnopqrstuvwxyz",   // lowercase
                "1234567890"                    // number
            ];
            let strLength = [3,1,1,1,quantity - 6];
            let ramdomArray = [];
            strLength.forEach(function callback(value, index) {
                while(value > 0) {
                    let numberIndex = index == 4 ? Math.floor(Math.random() * (3 - 1 + 1) + 1) : index;
                    ramdomArray.push(strText[numberIndex].substr(Math.floor(strText[numberIndex].length*Math.random()), 1));
                    if(index == 0 || index == 4) {
                        ramdomArray = ramdomArray.filter((item, i, ar) => ar.indexOf(item) === i);
                        if(index == 0 && ramdomArray.length == 3 || index == 4 && ramdomArray.length == quantity){
                            value = 0;
                        }
                    } else {
                        value = value - 1;
                    }
                }
            });
            this.$v.form.password.$model = ramdomArray.sort(()=>Math.random()-.5).join('');
            this.$v.form.repeatPassword.$model = this.$v.form.password.$model;
            this.showPasswordType = "text";
            this.iconShowPassword = "far fa-eye";
        },
        realtime: function(event,key){
            if(key == 'fullname'){
                var illegalChars = /[^A-Za-zก-ฮ\เ\แ\า\ๆ\ไ\ใ\โ\ๅ\ิ\ื\์\้\็\่\๋\๊\ี\ั\ํ\ุ\ู\ึ\๐ฺ\๐\ะ\ำ ]/gi;
                var illegalCharsOrMultipleSpaces = /[^A-Za-zก-ฮ\เ\แ\า\ๆ\ไ\ใ\โ\ๅ\ิ\ื\์\้\็\่\๋\๊\ี\ั\ํ\ุ\ู\ึ\๐ฺ\๐\ะ\ำ ]|\s\s/gi;
                if(event.target.value.search(illegalCharsOrMultipleSpaces) > -1) {
                    this.$v.form[key].$model = event.target.value.replace(illegalChars, "").replace(/\s+/g, " ");
                    return;
                }
            }
            this.$v.form[key].$model = event.target.value;
        },
        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1;
                    this.countDownTimer();
                }, 1000);
            }
        },
        selectLang(lang) {
            localSave("local", lang);
            location.reload();
        },
        handleRegister() {
            if (this.countDown > 0) {
                let textInputVerficationCode = this.inputVerficationCode;
                let textInputVerficationCodeLength =
                    textInputVerficationCode;
                let firstInputVerficationCode =
                    textInputVerficationCode.substr(0, 3);
                let endInputVerficationCode = textInputVerficationCode.substr(
                    3,
                    textInputVerficationCodeLength
                );
                let fullInputVerficationCode =
                    firstInputVerficationCode +
                    "GoSaaS" +
                    endInputVerficationCode;
                bcrypt
                    .compare(fullInputVerficationCode, this.verificationCode)
                    .then((res) => {
                        if (res === true) {
                            console.log("handleRegister");
                            this.loading = true;
                            let data = {
                                first_name: this.$v.form.fullname.$model,
                                last_name: this.$v.form.fullname.$model,
                                email: this.$v.form.email.$model,
                                mobile: this.$v.form.telephone.$model,
                                password: this.$v.form.password.$model,
                                coupon: this.$v.form.couponReferCode.$model,
                                ref: localRead("ref"),
                                mcode: localRead("mcode"),
                                uuid: localRead("uuid"),
                                utm_source: localRead("utm_source"),
                                utm_medium: localRead("utm_medium"),
                                utm_campaign: localRead("utm_campaign"),
                                utm_referer: localRead("utm_referer"),
                                utm_adsid: localRead("utm_adsid"),
                                password_confirmation:
                                    this.$v.form.repeatPassword.$model,
                                socialLogin: this.registerType === "socialRegister" ? this.socialUser : null
                            };
                        if(localRead("ref")) {
                            data['ref'] = localRead("ref");
                        }
                        if(localRead("utm_source")) {
                            data['utm_source'] = localRead("utm_source");
                        }
                        if(localRead("utm_medium")) {
                            data['utm_medium'] = localRead("utm_medium");
                        }
                        if(localRead("utm_campaign")) {
                            data['utm_campaign'] = localRead("utm_campaign");
                        }
                        if(localRead("utm_referer")) {
                            data['utm_referer'] = localRead("utm_referer");
                        }
                        if(localRead("utm_adsid")) {
                            data['utm_adsid'] = localRead("utm_adsid");
                        }
                        if(localRead("uuid")) {
                            data['uuid'] = localRead("uuid");
                        }

                        this.$store.dispatch('auth/register', data).then((response) => {
                            window.location.href = process.env.CENTRAL_ACC_URL + '/store'
                        },
                        error => {
                            this.message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                            this.loading = false;
                            console.log(this.message, 'error');
                        });
                    } else {
                        this.message = "Input verification code not match, Try again!";
                    }
                });
            } else {
                this.message = "This verify code timed out!";
            }
        },
        sendSelectVerify() {
            if(this.$v.validationGroup.$invalid == true) {
                $('#btnRegister button.btn.btn-ladda.btn-ladda-spinner.ladda-button.btn.btn-primary').attr('disabled', this.$v.validationGroup.$invalid);
                return;
            }
            if (!this.responseVerify) {
              this.alertVerifyCaptcha = true;
              return;
            } else {
              this.alertVerifyCaptcha = false;
            }
            this.loading = true;
            const menu =
            [
                {
                    id: 1,
                    title: this.$t('Verification code via email'),
                    description: this.form.email,
                    type: 'verify_email',
                    menuloading: false,
                    icon:['far','fa-envelope']
                },
                {
                    id: 2,
                    title: this.$t('Verification code via SMS'),
                    description: this.form.telephone.substr(this.form.telephone.length - 4),
                    type: 'verify_sms',
                    menuloading: false,
                    icon:['far','fa-sms']
                }
            ];
            this.menuVerificationCode = menu;
            setTimeout(() => {
                this.loading = false;
                this.alreadySend = true;
            }, 1000);
        },
        async sendMail() {
            let allow = await CentralApi.Auth.iswhitelistEmail(this.$v.form.email.$model);
            if(!allow.data.whitelist){
                let notAllowed = await CentralApi.Auth.isblacklistEmail(this.$v.form.email.$model);
                if(notAllowed.data.blacklist){
                    this.$toastr.Add({
                        type: "warning",
                        title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                        msg: this.$t("Email cannot be sent to")+" "+
                             this.$v.form.email.$model+" "+
                             this.$t("because this recipient is in blacklist.")+" "+
                             this.$t("If you feel this is a mistake, contact your admin."),
                        clickClose: true,
                        timeout: 5000,
                        position: "toast-top-right"
                    });
                    return false;
                }
            }
            this.loading = true;
            this.selectloading = true;
            this.menuVerificationCode[0].menuloading = true;
            this.verifyOption = 'verify_email';
            let params = {
                first_name: this.$v.form.fullname.$model,
                last_name: this.$v.form.fullname.$model,
                email: this.$v.form.email.$model,
            };
            try {
                let data = await CentralApi.Auth.emailSendVerifyV2(params);
                this.loading = false;
                this.selectloading = false;
                this.refCodeId = data.data.data.refcode;
                this.menuVerificationCode[0].menuloading = false;
                this.alreadyCode = true;
                this.verificationCode = data.data.data.random_number;
                if (this.countDown === 0) {
                    this.countDown = 120;
                    this.countDownTimer();
                } else {
                    this.countDown = 120;
                }
                return true;
            } catch (error) {
                this.loading = false;
                this.selectloading = false;
                this.menuVerificationCode[0].menuloading = false;
                let message = error.response.data.message;
                if(message == "This email is blacklisted.") {
                    message = this.$t("Email cannot be sent to")+" "+
                            this.$v.form.email.$model+" "+
                            this.$t("because this recipient is in blacklist.")+" "+
                            this.$t("If you feel this is a mistake, contact your admin.");
                }
                this.$toastr.Add({
                    type: "warning",
                    title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                    msg: message,
                    clickClose: true,
                    timeout: 5000,
                    position: "toast-top-right"
                });
                return false;
            }
        },
        async sendSms() {
            this.loading = true;
            this.selectloading = true;
            this.menuVerificationCode[1].menuloading = true;
            this.verifyOption = 'verify_sms';
            let params = {
                first_name: this.$v.form.fullname.$model,
                last_name: this.$v.form.fullname.$model,
                telephone: this.$v.form.telephone.$model,
                message: this.$t(`We're happy you signed up for Goship. Please confirm your mobile no. with OTP = {OTP} This code expired in 120 seconds`),
            };
            let data = await CentralApi.Auth.sendVerifySms(params);
            this.loading = false;
            this.selectloading = false;
            this.refCodeId = data.data.refcode;
            this.menuVerificationCode[1].menuloading = false;
            this.alreadyCode = true;
            this.verificationCode = data.data.randomNumber;
            if (this.countDown === 0) {
                this.countDown = 120;
                this.countDownTimer();
            } else {
                this.countDown = 120;
            }
        },
        backRegister() {
            this.alreadySend = false;
            this.responseVerify = "";
            this.alertVerifyCaptcha = false;
        },
        async showPassword() {
            this.showPasswordType =
                this.showPasswordType === "password" ? "text" : "password";
            this.iconShowPassword =
                this.iconShowPassword === "far fa-eye-slash"
                    ? "far fa-eye"
                    : "far fa-eye-slash";
        },
        async showConfirmPassword() {
            this.showConfirmPasswordType =
                this.showConfirmPasswordType === "password"
                    ? "text"
                    : "password";
            this.iconConfirmShowPassword =
                this.iconConfirmShowPassword === "far fa-eye-slash"
                    ? "far fa-eye"
                    : "far fa-eye-slash";
        },
        async selectVerifyOption(key) {
            switch (key) {
                case 'verify_email':
                    this.sendMail();
                    break;
                case 'verify_sms':
                    this.sendSms();
                    break;
                default:
                    break;
            }
        },
        handleSocialLogin: function(provider) {
          if (!this.responseVerify) {
            this.alertVerifyCaptcha = true;
            return;
          } else {
            this.alertVerifyCaptcha = false;
          }
          let routeData = this.$router.resolve({name: 'routeName', query: {data: "someData"}});
          if((provider === 'facebook' || provider === 'apple') && process.env.NODE_ENV === 'local') return ;


            const uuidV4 = uuid.v4()

            let socialLogin = window.open(process.env.BASEURL + `/v1/auth/watiting`);
            if (socialLogin) {
              setTimeout(() => {
                socialLogin.location.href = process.env.API_BASE_URL + `/v1/auth/${provider}/login?code=${uuidV4}`;
              }, 3000);
            }
            if(provider == 'apple') {
                Cookies.set('closeAppleAuthTab', 'false')
                //web sockets listen

                let channelName = "socialAppleLoginChannel" + uuidV4

                
            } else {
                //web sockets listen

                let channelName = "socialLoginChannel" + uuidV4

            }
        },
        onRecaptchaVerify(response) {
          this.responseVerify = response
          if (this.responseVerify) {
            this.alertVerifyCaptcha = false;
          }
        },
        resetRecaptcha() {
          this.$refs.recaptcha.reset();
          this.alertVerifyCaptcha = false;
        },
        onRecaptchaExpired() {
          this.responseVerify = '';
          this.alertVerifyCaptcha = true;
        },
        onRecaptchaError() {
          this.responseVerify = '';
          this.alertVerifyCaptcha = true;
        }
    },
    mounted() {
        if (this.$route.query.ref) {
            localSave("ref", this.$route.query.ref);
        }

        if (this.$route.query.mcode) {
            localSave("mcode", this.$route.query.mcode);
        }

        if (this.$route.query.utm_source) {
            localSave("utm_source", this.$route.query.utm_source);
        }

        if (this.$route.query.utm_medium) {
            localSave("utm_medium", this.$route.query.utm_medium);
        }

        if (this.$route.query.utm_campaign) {
            localSave("utm_campaign", this.$route.query.utm_campaign);
        }

        if (this.$route.query.utm_referer) {
            localSave("utm_referer", this.$route.query.utm_referer);
        }

        if (this.$route.query.utm_adsid) {
            localSave("utm_adsid", this.$route.query.utm_adsid);
        }

        if (this.$route.query.uuid) {
            localSave("uuid", this.$route.query.uuid);
        }

        this.form.email = this.socialUser ? this.socialUser.email : "" ;

        if (this.$route.query.refer) {
            localSave("refer", this.$route.query.refer);
        }

        if(typeof this.$route.query.mcode === 'undefined' && typeof this.$route.query.uuid === 'undefined'){
            this.form.couponReferCode = localRead("refer");
        }
    },
};
</script>
<style scoped>
    input[type="email"],
    input[type="text"],
    input[type="password"] {
        font-family: "Sarabun", sans-serif;
    }
    div.validation-invalid-label {
        display: none !important;
    }
    div.form-group-error > div.validation-invalid-label {
        display: block !important;
    }
    div.form-group-success > div.validation-invalid-label {
        display: none !important;
    }
    .f-18{
      font-size: 18px;
    }

    .text-size-13 {
        font-size: 13px !important;
    }

    #generate .btn.btn-outline:hover {
        color: #333 !important;
        background-color: #fafafa;
        border-color: #ddd;
    }

    .icon-mark-1 {
        left: auto;
        right: 0px;
        font-size: 13px;
    }

    .icon-mark-2 {
        left: auto;
        right: 22px;
        margin-top: -0.7%;
    }

    .valid-password {
        display: block;
        margin: 0px;
        max-width: 100% !important;
        width: max-content !important;
        bottom: 42px;
        top: auto;
        right: auto;
        left: 355px;
        bottom: -73px;
        z-index: 101;
    }

    .valid-arrow {
        top: 50%;
        margin-top: -2.5px;
    }

    .custom-control-label::after, .custom-control-label::before {
      width: 1rem;
      height: 1rem;
      left: -1.75rem;
      top: 0.15rem;
      border-color: #455964 !important;
    }

    .f-14 {
      font-size: 14px;
    }

    @media only screen and (max-width: 881px) {
        .valid-password {
            top: auto;
            right: auto;
            left: auto;
            bottom: 45px;
            max-width: 100% !important;
        }
        .valid-arrow {
            top: auto;
            margin-top: 0px;
            left: 45%;
            margin-left: -2.5px;
        }
        .bs-popover-auto[x-placement^=right]>.arrow, .bs-popover-right>.arrow {
            bottom: calc((0.375rem + 1px) * -1);
            width: 0.75rem;
            height: 0.375rem;
            margin: 0 0.25rem;
        }
        .bs-popover-auto[x-placement^=right]>.arrow::before, .bs-popover-right>.arrow::before {
            bottom: 0;
            border-width: 0.375rem 0.375rem 0;
            border-top-color: rgba(0,0,0,.2);
            left: 10%;
            border-right-color: rgb(0 0 0 / 0%);
        }
        .bs-popover-auto[x-placement^=right]>.arrow::after, .bs-popover-right>.arrow::after {
            bottom: 1px;
            border-width: 0.375rem 0.375rem 0;
            border-top-color: #fff;
            border-right-color: rgb(0 0 0 / 0%);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/central/authorization/Register.vue